import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { GetChatUsersResponse } from "../../Types/Chat";

interface GlobalState {
    isLoggedIn: boolean
    showBackButton: boolean
    userType: 'client' | 'talent' | undefined
    userId: string | undefined
    prevLocation: string
    themeMode: 'light' | 'dark'
    isAdmin: boolean;
    defaultPaymentMethod: any;
    clientSecret: string | null;
    customerSessionClientSecret: string | null;
    chatUsers: GetChatUsersResponse | null;
}

const initialState: GlobalState = {
    isLoggedIn: false,
    showBackButton: false,
    userType: undefined,
    userId: undefined,
    prevLocation: '/',
    themeMode: 'light',
    isAdmin: false,
    defaultPaymentMethod: null,
    clientSecret: null,
    customerSessionClientSecret: null,
    chatUsers: null
}

export const globalSlice = createSlice({
    name: 'Global',
    initialState,
    reducers: {
        setIsLoggedIn(state, action: PayloadAction<GlobalState["isLoggedIn"]>){
            state.isLoggedIn = action.payload;
        },
        setUserType(state, action: PayloadAction<GlobalState["userType"]>){
            state.userType = action.payload;
        },
        setUserId(state, action: PayloadAction<GlobalState["userId"]>){
            state.userId = action.payload;
        },
        setPrevLocation(state, action: PayloadAction<GlobalState["prevLocation"]>){
            state.prevLocation = action.payload;
        },
        setShowBackButton(state, action: PayloadAction<GlobalState["showBackButton"]>){
            state.showBackButton = action.payload;
        },
        setThemeMode(state, action: PayloadAction<GlobalState["themeMode"]>){
            state.themeMode = action.payload;
        },
        resetPrevLocation(state) {
            state.prevLocation = '/';
        },
        setIsAdmin(state, action: PayloadAction<GlobalState["isAdmin"]>){
            state.isAdmin = action.payload;
        },
        setDefaultPaymentMethod(state, action: PayloadAction<GlobalState["defaultPaymentMethod"]>){
            state.defaultPaymentMethod = action.payload;
        },
        setClientSecret(state, action: PayloadAction<GlobalState["clientSecret"]>){
            state.clientSecret = action.payload;
        },
        setCustomerSessionClientSecret(state, action: PayloadAction<GlobalState["customerSessionClientSecret"]>){
            state.customerSessionClientSecret = action.payload;
        },
        setChatUsers(state, action: PayloadAction<GlobalState["chatUsers"]>){
            state.chatUsers = action.payload
        },
        resetGlobalSlice: () => initialState
    }
})

export const {
    setIsLoggedIn,
    setUserType,
    setUserId,
    setPrevLocation,
    resetPrevLocation,
    setShowBackButton,
    setThemeMode,
    setIsAdmin,
    setDefaultPaymentMethod,
    setClientSecret,
    setCustomerSessionClientSecret,
    setChatUsers,
    resetGlobalSlice
} = globalSlice.actions

export default globalSlice.reducer

